import React from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';

const SubMenu = () => (
  <nav className="admin-sub-menu">
    <div className="admin-sub-menu__container">
      <Menu
        className="admin-sub-menu__item"
        mode="inline"
      >
        <Menu.SubMenu
          key="web"
          title="WEB"
        >
          <Menu.Item key="1"><Link to="/hero-banner/update">Hero Banner</Link></Menu.Item>
          <Menu.Item key="2"><Link to="/cards">Cards</Link></Menu.Item>
          <Menu.Item key="3"><Link to="/megaphone-banner/update">Megaphone Banner</Link></Menu.Item>
        </Menu.SubMenu>
      </Menu>
      <Menu
        className="admin-sub-menu__item"
        mode="inline"
      >
        <Menu.SubMenu
          key="web"
          title="MOBILE APP"
        >
          <Menu.Item key="1"><Link to="/mobile/cards">Cards</Link></Menu.Item>
          <Menu.Item key="2"><Link to="/mobile/box-tab">Box Tab</Link></Menu.Item>
          <Menu.Item key="3"><Link to="/mobile/manage-card">Manage Card</Link></Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </div>
  </nav>
);

export default SubMenu;
